import request from "../../utils/request";
import {
    UserGrossPayView,
    UserGrossPayInput,
    CompanyGrossPayView,
    CompanyGrossPayInput
} from "../../models/payroll";
import { Bank, Result, User } from "../../models/general";


export async function GetUserGrossPaysPerMonth(userId: string, date: string, currencyId: number) {
    const response = await request.get<Result<UserGrossPayView[]>>("GrossPay/GetUserGrossPaysPerMonth", {
        params: { userId, date, currencyId },
    });
    return response.data;
}

export async function AddUserGrossPay(input: UserGrossPayInput) {
    const response = await request.post<Result<UserGrossPayView>>("GrossPay/AddUserGrossPay", input);
    return response.data;
}

export async function UpdateUserGrossPay(input:UserGrossPayInput) {
    const response=await request.post<Result<UserGrossPayView>>(`GrossPay/UpdateUserGrossPay`, input);
    return response.data;
}

export async function GetCompanyGrossPays() {
    const response = await request.get<Result<CompanyGrossPayView[]>>(`GrossPay/GetCompanyGrossPays`);
    return response.data;
}

export async function EditCompanyGrossPay(input : CompanyGrossPayInput) {
    const response = await request.post<Result<CompanyGrossPayView>>(`GrossPay/EditCompanyGrossPay`, input);
    return response.data;
}

export async function DeleteCompanyGrossPay(id: number) {
    const response = await request.post<Result<boolean>>(`GrossPay/DeleteCompanyGrossPay/${id}`);
    return response.data;
}

export async function AddCompanyGrossPay(input: CompanyGrossPayInput) {
    const response = await request.post<Result<CompanyGrossPayView>>("GrossPay/AddCompanyGrossPay", input);
    return response.data;
}
